import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: "",
    user_img: '',
    user_info: ''
  },
  mutations: {
    getToken(state, data) {
      state.user = data;
    },
  },
  actions: {},
  modules: {},
});
